var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#162B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 40H17.5C16.1193 40 15 41.1193 15 42.5V67.5C15 68.8807 16.1193 70 17.5 70H82.5C83.8807 70 85 68.8807 85 67.5V42.5C85 41.1193 83.8807 40 82.5 40Z",
    fill: "#E2F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5001 70.38H17.5001C15.9201 70.38 14.6201 69.09 14.6201 67.5V42.5C14.6201 40.91 15.9101 39.62 17.5001 39.62H82.5001C84.0801 39.62 85.3801 40.91 85.3801 42.5V67.5C85.3801 69.09 84.0901 70.38 82.5001 70.38ZM17.5001 40.38C16.3301 40.38 15.3801 41.33 15.3801 42.5V67.5C15.3801 68.67 16.3301 69.62 17.5001 69.62H82.5001C83.6701 69.62 84.6201 68.67 84.6201 67.5V42.5C84.6201 41.33 83.6701 40.38 82.5001 40.38H17.5001Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25 35H18.75C18.0596 35 17.5 35.5596 17.5 36.25C17.5 36.9404 18.0596 37.5 18.75 37.5H81.25C81.9404 37.5 82.5 36.9404 82.5 36.25C82.5 35.5596 81.9404 35 81.25 35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.25 30H23.75C23.0596 30 22.5 30.5596 22.5 31.25C22.5 31.9404 23.0596 32.5 23.75 32.5H76.25C76.9404 32.5 77.5 31.9404 77.5 31.25C77.5 30.5596 76.9404 30 76.25 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.25 25H28.75C28.0596 25 27.5 25.5596 27.5 26.25C27.5 26.9404 28.0596 27.5 28.75 27.5H71.25C71.9404 27.5 72.5 26.9404 72.5 26.25C72.5 25.5596 71.9404 25 71.25 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 65C55.5228 65 60 60.5228 60 55C60 49.4772 55.5228 45 50 45C44.4772 45 40 49.4772 40 55C40 60.5228 44.4772 65 50 65Z",
    fill: "#4782FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.100a91235a3abe10119e261b3879577d.svg";
export { ForwardRef as ReactComponent };